var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileGiftCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_29376",
    "data-name": "Group 29376",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.142,
    height: 20,
    viewBox: "0 0 24.142 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3468",
    "data-name": "Rectangle 3468",
    width: 24.142,
    height: 20,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29375",
    "data-name": "Group 29375",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38186",
    "data-name": "Path 38186",
    d: "M27.767,31.359H8.878A1.177,1.177,0,0,1,7.7,30.183V18.75a1.177,1.177,0,0,1,1.176-1.176H27.767a1.177,1.177,0,0,1,1.176,1.176V30.182a1.177,1.177,0,0,1-1.176,1.176",
    transform: "translate(-6.34 -14.466)",
    fill: "none",
    stroke: "#fc3",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_475",
    "data-name": "Line 475",
    x2: 21.242,
    transform: "translate(1.362 8.739)",
    fill: "none",
    stroke: "#fc3",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38187",
    "data-name": "Path 38187",
    d: "M27.767,31.358H8.878A1.177,1.177,0,0,1,7.7,30.182V18.749a1.177,1.177,0,0,1,1.176-1.176H27.767a1.177,1.177,0,0,1,1.176,1.176V30.181a1.177,1.177,0,0,1-1.176,1.176",
    transform: "translate(-6.34 -14.466)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_476",
    "data-name": "Line 476",
    y2: 13.773,
    transform: "translate(7.715 3.133)",
    fill: "none",
    stroke: "#fc3",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38188",
    "data-name": "Path 38188",
    d: "M21.661,38.68A5.29,5.29,0,0,1,23.19,35.9a6.763,6.763,0,0,1,2.684-1.4,10.437,10.437,0,0,0,2.5-.78,1.119,1.119,0,0,0,.281-1.841,1.234,1.234,0,0,0-1.529-.094,5.967,5.967,0,0,0-2.091,2.465v0a5.961,5.961,0,0,0-2.091-2.465,1.234,1.234,0,0,0-1.529.094,1.12,1.12,0,0,0,.281,1.841,10.431,10.431,0,0,0,2.5.78,6.76,6.76,0,0,1,2.684,1.4A5.284,5.284,0,0,1,28.4,38.678",
    transform: "translate(-17.316 -25.971)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileGiftCard);
export default __webpack_public_path__ + "static/media/profile-gift-card.e9ef46cbeca62a580d54a60d609bbb45.svg";
export { ForwardRef as ReactComponent };